import { Image } from 'antd';

const MobileIntroDialog = () => {
  const dataList = [
    {
      id: 1,
      img: 'https://static.szlcsc.com/ecp/assets/newWeb/header/xcx_new.png',
      title: '微信小程序',
      desc: '找料更方便',
    },
    {
      id: 2,
      img: 'https://static.szlcsc.com/ecp/assets/newWeb/header/app_new.png',
      title: '立创APP',
      desc: '体验更友好',
    },
    {
      id: 3,
      img: 'https://static.szlcsc.com/ecp/assets/newWeb/header/gzh_new.png',
      title: '立创公众号',
      desc: '售前咨询，优惠活动',
    },
  ];

  return (
    <ul className="w-[371px] p-[10px] flex justify-between">
      {dataList.map((data) => (
        <li key={data.id} className="text-center">
          <Image
            width={100}
            height={100}
            className="mx-auto img-pixel"
            src={data.img}
            alt={data.title}
            preview={false}
          />
          <p className="text-[14px] text-black leading-[20px] mt-[8px]">{data.title}</p>
          <p className="text-[#54657D] leading-[20px] mt-[4px] text-[12px]">{data.desc}</p>
        </li>
      ))}
    </ul>
  );
};

export default MobileIntroDialog;
